<div style="width:100%; padding-top:10px;">
  <form #fileUploadForm="ngForm">
    <input style="min-width: 120px;" type="text" class="form-control" placeholder="Format Name" name="formatName"
      [(ngModel)]="formatName"><br />
      <div class="form-group">
        <label for="declaration">{{'FUSION.DECLARATION' | translate}}</label>
        <select [(ngModel)]="declaration" id="declaration" class="form-control" name="declaration"
          (change)="onDeclarationChange($event.target.value)">
          @for (value of declarations; track value) {
            <option value="{{value.id}}">
              {{value.name}}
            </option>
          }
        </select>
      </div>
      <div class="form-group">
        <label for="stage">{{'FUSION.STAGE' | translate}}</label>
        <select [(ngModel)]="stage" id="stage" class="form-control" name="stage"  (change)="onStageChange($event.target.value)">
          @for (value of stages; track value) {
            <option  value="{{value.key}}">
              {{value.name || value.key}}
            </option>
          }
        </select>
      </div>
      <div class="form-group">
        <label for="block">{{'FUSION.BLOCK' | translate}}</label>
        <select [(ngModel)]="block" id="block" class="form-control" name="block" (change)="onBlockChange($event.target.value)">
          @for (value of blocks; track value) {
            <option [ngValue]="value">
              {{value.name.trim()!==''? value.name:value.key}}
            </option>
          }
        </select>
      </div>
      <div class="form-check form-switch">
        <input type="checkbox" class="form-check-input" id="fluxFusion"
          [checked]="flux" (change)="flux = !flux" name="flux">
          <label for="fluxFusion" class="form-check-label">{{'FUSION.FLUX_COLUMN' | translate}}</label>
        </div>
        <app-special-columns-editor
          [columns]="sourceColumns"
          [(specialColumns)]="specialColumns">
        </app-special-columns-editor>
      </form>
      <div style="overflow-x: auto;">
        @if (block && block.headers) {
          <table class="table table-bordered">
            <thead>
              <tr>
                @for (column of block.headers; track column) {
                  <th>{{ column.name }}</th>
                }
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
        }
      </div>
      <div>
        <hr />
        <div>
          <button type="button" class="btn btn-danger btn-s" (click)="apply()"
            [disabled]="!formatName || !declaration || !stage || !block">
            <span class="glyphicon glyphicon-ok"></span> {{'FUSION.SAVE' | translate }}
          </button>
          <button type="button" class="btn btn-warning btn-s" (click)="closeWindow()">
            <span class="glyphicon glyphicon-ban-circle"></span> {{'FUSION.CANCEL' | translate }}
          </button>
        </div>
      </div>
    </div>